<template>
  <div class="cycle_data" v-if="clazz && clazzStat">
    <clazz-show-header :clazz="clazz" />

    <van-cell
      class="mt15"
      title-class="custom_cell__title_color"
      title="统计信息"
    >
      <van-icon class="stat_icon" slot="icon" name="bar-chart-o" />
    </van-cell>
    <van-cell title="加入日期" :value="clazzStat.join_time" />
    <van-cell title="已打卡天数" :value="clazzStat.days + '天'" />
    <!-- <van-cell title="已打卡记录数" :value="clazzStat.record_num + '次'" /> -->
    <van-cell v-if="clazz.clazz_type===1" title="跑步里程数" :value="clazzStat.distance + '公里'" />

    <van-cell
      class="mt15"
      title-class="custom_cell__title_color"
      title="我的打卡日历"
    >
      <van-icon class="stat_icon" slot="icon" name="bar-chart-o" />
    </van-cell>

    <my-calendar
      :day-events="dayEvents"
      @month-change="monthChange"
      @day-click="dayClick"
    />

    <van-cell
      class="mt15"
      title-class="custom_cell__title_color"
      :title="selectedDate + '打卡信息'"
    >
      <van-icon class="stat_icon" slot="icon" name="records" />
    </van-cell>

    <record-panel
      class="bgwhite"
      v-for="(item, index) in recordList"
      :key="index"
      :record="item"
      :has-footer="false"
      :has-toolbar="false"
    />

    <div v-if="noRecordList" class="empty bgwhite">
      无打卡记录
    </div>

    <!-- <div class="bottom"></div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Cell, Icon, Toast } from 'vant'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import MyCalendar from '@/components/MyCalendar'
import RecordPanel from '@/views/record/components/RecordPanel'
import { formatDate } from '@/utils/index'
import { clazzSimpleInfo } from '@/api/clazz'
import { userClazzStat, userClazzMonthStat, userClazzDayRecord } from '@/api/record'

export default {
  name: 'CycleData',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    ClazzShowHeader,
    MyCalendar,
    RecordPanel
  },
  data () {
    return {
      clazzId: undefined,
      clazz: null,
      clazzStat: null,
      selectedDate: '',
      dayEvents: [],
      recordList: []
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ]),
    noRecordList () {
      return !this.recordList.length
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.userId = this.userprofile.uuid
    this.selectedDate = formatDate(new Date())

    this.getClazzInfo()
    this.getMyStat()
    this.getMonthStat()
    this.getDayRecord()
  },
  methods: {
    async getClazzInfo () {
      let response = await clazzSimpleInfo(this.clazzId)
      this.clazz = response.data
    },
    async getMyStat () {
      let response = await userClazzStat(this.clazzId, this.userId)
      Toast.clear()
      this.clazzStat = response.data
    },
    async getMonthStat (day) {
      let response = await userClazzMonthStat(this.clazzId, this.userId, day)
      Toast.clear()
      this.dayEvents = response.data
    },
    async getDayRecord (day) {
      let response = await userClazzDayRecord(this.clazzId, this.userId, day)
      Toast.clear()
      this.recordList = response.data
    },
    monthChange (date) {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      this.getMonthStat(date)
    },
    dayClick (date) {
      this.selectedDate = date
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      this.getDayRecord(date)
    }
  }
}
</script>

<style scoped lang="scss">
.cycle_data {
  background-color: #f8f8f8;
  .stat_icon {
    height: 48px;
    min-width: 1em;
    font-size: 34px;
    line-height: 48px;
    margin-right: 10px;
    color: #969799;
  }
  .empty {
    height: 80px;
  }
  .bottom {
    height: 30px;
  }
}
</style>
